import { render, staticRenderFns } from "./user-card.vue?vue&type=template&id=57a35dd8&scoped=true&"
import script from "./user-card.vue?vue&type=script&lang=js&"
export * from "./user-card.vue?vue&type=script&lang=js&"
import style0 from "./user-card.vue?vue&type=style&index=0&id=57a35dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a35dd8",
  null
  
)

export default component.exports